// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__h0nmK","header":"Messages_header__m65Qc"};